import Close from "@store/Components/Icons/Close";
import { polyfillCss } from "@store/theme/polyfills";

export default {
    defaultProps: {
        cssOverrides: {
            titleButton: polyfillCss`
                ${props => props.theme.modal?.defaultProps?.cssOverrides?.titleButton}

                &:active, &:hover {
                    border-color: transparent;
                    background: transparent;
				}
            `,
            modalContent: polyfillCss`
                overflow-y: auto;
				overflow-x: hidden;
            `,
        },
        closeButtonIconProps: {
            src: Close,
        },
    },
};
